module.exports = __webpack_public_path__ + "img/28.23232777.jpg";